import React, { ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../utils/PropTypesDefinitions'
import Image from '../BaseComponents/Image'
import Label from '../BaseComponents/Labels/Basic'
import { AspectRatioTypes } from '../BaseComponents/Image/ImageInterfaces'
import LinkProps from '../Link/LinkProps'

export type BasicProps = {
    /** the url of the image */
    imageUrl?: string
    /** alternate text for image */
    alt?: string
    /** align the image**
     * @defaultValue left
     */
    align?: 'left' | 'center' | 'right'
    /** text for the label */
    labelText?: string
    /** href string to navigate to the provided url (web only) */
    href?: string
    /** specifies where to open the link**
     * @defaultValue _blank
     */
    target?: '_blank' | '_self'
    /**
     * callback when the user pressed on the component
     *
     * @TJS-type function
     */
    onPress?: () => void
    /** position of the label 'left' beside the logo or with 'top' above and centered **
     * @defaultValue left
     */
    type?: 'left' | 'top'
    /** flag to ignore the ratio of the logo which returns 1 at ORIGINAL but in this case we want undefined*/
    ignoreAspectRatio?: boolean
    imageWidth?: string
    /** aspect ratio of the logo **
     * @defaultValue ORIGINAL
     */
    aspectRatio?: AspectRatioTypes
} & LinkProps &
    TestID

const Basic = ({
    labelText,
    imageUrl,
    alt,
    align = 'left',
    href,
    target = '_blank',
    onPress,
    type = 'left',
    testID,
    imageWidth,
    aspectRatio = 'ORIGINAL',
    webRel,
}: BasicProps): ReactElement => {
    return (
        <Touchable onPress={onPress} href={href} webTarget={target} webRel={webRel}>
            <Grid
                noExpand
                testID={testID}
                horizontal={type === 'left'}
                alignLeft={'left' === align}
                alignRight={'right' === align}
                centerHorizontal={'center' === align}
                width="100%"
            >
                {labelText ? (
                    <Grid
                        noExpand
                        paddingRight={type === 'left' ? 5 : undefined}
                        paddingBottom={type === 'top' ? 5 : undefined}
                    >
                        <Label backgroundColor="onyx" fontColor="pearl">
                            {labelText}
                        </Label>
                    </Grid>
                ) : null}
                <Grid noExpand height={72} width={aspectRatio === '1:1' ? undefined : imageWidth}>
                    <Image
                        ignoreAspectRatio={aspectRatio === 'ORIGINAL'}
                        imageUrl={imageUrl}
                        alt={alt}
                        size="L"
                        height="100%"
                        maxHeight={72}
                        resizeMode="contain"
                        aspectRatio={aspectRatio}
                    />
                </Grid>
            </Grid>
        </Touchable>
    )
}

export default memo(Basic)
